import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import StyledText from '#components/a/StyledText'
import NachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import {routeHelper} from '#config/routeKeys'

export default class NachweisFreigebenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, nachweisId} = this.props
    onNotificationClick(routeHelper.ausbildungsnachweisDetail(nachweisId))
  }

  render() {
    const text = i18n.t('notification_text_nachweis_freigeben', [this.props.nachweisNummer])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification nachweis_notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <div className="notification__icon">
          <NachweisIcon />
        </div>
        <StyledText text={text} modifier="notification" />
      </div>
    )
  }
}

NachweisFreigebenBenachrichtigung.propTypes = {
  nachweisId: PropTypes.string,
  nachweisNummer: PropTypes.number,
  onNotificationClick: PropTypes.func.isRequired,
}
